import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import NoOverflowContainer from './NoOverflowContainer';
import styles from './NoOverflowContainer.styles';

const mapStateToProps = ({ clientingModule: { voice } }) => ({
  hasCallInProgress: voice?.hasCallInProgress,
  isMinimized: voice?.isMinimized,
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(NoOverflowContainer);
